module.exports = __webpack_public_path__ + "img/logo.9b85fc1b.png";